const BorrowBaseCovenantView = () => {
  return (
    <div className="borrow-base-cov-view">
      <h1>Placeholder for Borrowing Base Covenant View</h1>
    </div>
  );
};

export default BorrowBaseCovenantView;
